// extracted by mini-css-extract-plugin
export var quillEditor = "_qi-1";
export var variable = "_qi-0";